import { $t } from "@/plugins/i18n";

import { useHotelOrderListStoreHook } from "../../store/hotelOrderList";

export default [
  {
    path: "/orders",
    name: "orderList",
    component: () => import("../../views/order/list/index.vue"),
    meta: {
      title: $t("shell.breadcrumb.myOrders"),
      keepAlive: true,
      showLink: false,
      requireLogin: true,
      rank: 101,
      beforeEnter: query => {
        if (!query) {
          return;
        }
        const store = useHotelOrderListStoreHook();
        store.getOrders();
      }
    }
  },
  {
    path: "/orders/:id",
    name: "orderDetail",
    component: () => import("../../views/order/detail/index.vue"),
    meta: {
      title: $t("shell.breadcrumb.orderDetail"),
      showLink: false,
      requireLogin: true,
      rank: 101
    }
  }
];
